import { MarketingTermTooltip } from './Html';
export var terms = [
    {
        key: 'age',
        title: '만 14세 이상',
        isRequired: true,
    },
    {
        key: 'service',
        title: '서비스 약관 동의',
        isRequired: true,
        link: 'https://teamsparta.notion.site/247d57da1322424d8e8c551df21a048e',
    },
    {
        key: 'privacy',
        title: '개인정보처리방침 및 제3자 제공 동의',
        isRequired: true,
        link: 'https://teamsparta.notion.site/7b1dc644460946f08bab08b794de685f',
    },
    {
        key: 'marketing',
        title: '광고성 정보 수신 동의',
        tooltip: MarketingTermTooltip,
    },
];
export var initialTermsAgreement = terms.reduce(function (acc, term) {
    acc[term.key] = false;
    return acc;
}, {});
export var Genders = [
    { key: 'male', label: '남자' },
    { key: 'female', label: '여자' },
    {
        key: 'undefined',
        label: '선택 안함',
    },
];
export var countryInfosExistInUsers = [
    { alpha2Code: 'US', name: 'United States', callingCode: '1' },
    { alpha2Code: 'ID', name: 'Indonesia', callingCode: '62' },
    { alpha2Code: 'GB', name: 'United Kingdom', callingCode: '44' },
    { alpha2Code: 'RU', name: 'Russia', callingCode: '7' },
    { alpha2Code: 'VN', name: 'Vietnam', callingCode: '84' },
    { alpha2Code: 'CN', name: 'China', callingCode: '86' },
    { alpha2Code: 'AU', name: 'Australia', callingCode: '61' },
    { alpha2Code: 'JP', name: 'Japan', callingCode: '81' },
    { alpha2Code: 'MY', name: 'Malaysia', callingCode: '60' },
    { alpha2Code: 'SG', name: 'Singapore', callingCode: '65' },
    { alpha2Code: 'HK', name: 'Hong Kong', callingCode: '852' },
    { alpha2Code: 'HU', name: 'Hungary', callingCode: '36' },
    { alpha2Code: 'AT', name: 'Austria', callingCode: '43' },
    { alpha2Code: 'AE', name: 'United Arab Emirates', callingCode: '971' },
    { alpha2Code: 'ES', name: 'Spain', callingCode: '34' },
    { alpha2Code: 'DE', name: 'Germany', callingCode: '49' },
    { alpha2Code: 'NZ', name: 'New Zealand', callingCode: '64' },
    { alpha2Code: 'MX', name: 'Mexico', callingCode: '52' },
    { alpha2Code: 'TR', name: 'Turkey', callingCode: '90' },
    { alpha2Code: 'SE', name: 'Sweden', callingCode: '46' },
    { alpha2Code: 'ZA', name: 'South Africa', callingCode: '27' },
    { alpha2Code: 'FR', name: 'France', callingCode: '33' },
    { alpha2Code: 'PH', name: 'Philippines', callingCode: '63' },
    { alpha2Code: 'TH', name: 'Thailand', callingCode: '66' },
    { alpha2Code: 'EG', name: 'Egypt', callingCode: '20' },
    { alpha2Code: 'KH', name: 'Cambodia', callingCode: '855' },
    { alpha2Code: 'KZ', name: 'Kazakhstan', callingCode: '7' },
    { alpha2Code: 'KE', name: 'Kenya', callingCode: '254' },
    { alpha2Code: 'AR', name: 'Argentina', callingCode: '54' },
    { alpha2Code: 'BR', name: 'Brazil', callingCode: '55' },
    { alpha2Code: 'GH', name: 'Ghana', callingCode: '233' },
    { alpha2Code: 'LA', name: 'Laos', callingCode: '856' },
    { alpha2Code: 'PK', name: 'Pakistan', callingCode: '92' },
    { alpha2Code: 'GT', name: 'Guatemala', callingCode: '502' },
    { alpha2Code: 'CO', name: 'Colombia', callingCode: '57' },
    { alpha2Code: 'NL', name: 'Netherlands', callingCode: '31' },
    { alpha2Code: 'IT', name: 'Italy', callingCode: '39' },
    { alpha2Code: 'HN', name: 'Honduras', callingCode: '504' },
    { alpha2Code: 'QA', name: 'Qatar', callingCode: '974' },
    { alpha2Code: 'CH', name: 'Switzerland', callingCode: '41' },
    { alpha2Code: 'NO', name: 'Norway', callingCode: '47' },
    { alpha2Code: 'FI', name: 'Finland', callingCode: '358' },
    { alpha2Code: 'SA', name: 'Saudi Arabia', callingCode: '966' },
    { alpha2Code: 'IL', name: 'Israel', callingCode: '972' },
    { alpha2Code: 'NI', name: 'Nicaragua', callingCode: '505' },
    { alpha2Code: 'CZ', name: 'Czech Republic', callingCode: '420' },
    { alpha2Code: 'PL', name: 'Poland', callingCode: '48' },
    { alpha2Code: 'RO', name: 'Romania', callingCode: '40' },
    { alpha2Code: 'LK', name: 'Sri Lanka', callingCode: '94' },
    { alpha2Code: 'SV', name: 'El Salvador', callingCode: '503' },
    { alpha2Code: 'MN', name: 'Mongolia', callingCode: '976' },
    { alpha2Code: 'NG', name: 'Nigeria', callingCode: '234' },
    { alpha2Code: 'IE', name: 'Ireland', callingCode: '353' },
    { alpha2Code: 'UZ', name: 'Uzbekistan', callingCode: '998' },
    { alpha2Code: 'TW', name: 'Taiwan', callingCode: '886' },
    { alpha2Code: 'SK', name: 'Slovakia', callingCode: '421' },
    { alpha2Code: 'ET', name: 'Ethiopia', callingCode: '251' },
    { alpha2Code: 'MM', name: 'Myanmar', callingCode: '95' },
    { alpha2Code: 'SS', name: 'South Sudan', callingCode: '211' },
    { alpha2Code: 'PT', name: 'Portugal', callingCode: '351' },
    { alpha2Code: 'CL', name: 'Chile', callingCode: '56' },
    { alpha2Code: 'IN', name: 'India', callingCode: '91' },
    { alpha2Code: 'KR', name: 'South Korea', callingCode: '82' },
    { alpha2Code: 'EC', name: 'Ecuador', callingCode: '593' },
    { alpha2Code: 'PY', name: 'Paraguay', callingCode: '595' },
];
//# sourceMappingURL=index.js.map